import React from "react";
import styles from "./MarketplaceAdvisorCard.module.scss";
import { Link } from "react-router-dom"
import useGetProfilePicture from "../../../hooks/useGetProfilePicture";
import { MapPin } from 'react-feather'
const classnames = require('classnames');

function MarketplaceAdvisorCard(props) {

    const { professionalId, cognitoUsername, firstName, lastName, city, state, companyName, jobTitle, yearsOfExperience, specialities, services, clientele, pricing, displayDistance, firmId } = props.data;
    const profilePicture = useGetProfilePicture(firmId && firmId > 0 ? professionalId : cognitoUsername);

    return (
        <>
            <Link className={styles.advisorCardContainer} to={`/advisor-profile/${professionalId}/${firstName}-${lastName}/`} target="_blank" rel="noopener noreferrer">
                <div className={styles.advisorInfoContainer}>
                    <div className={styles.profilePictureContainer}>
                        {profilePicture && <img loading="lazy" className={classnames(styles.profilePicture, !(profilePicture === '/images/profilePictureDefault.svg') ? styles.gradientBorder : styles.pupleBorder)} src={profilePicture} alt="profile_picture" ></img>}
                    </div>
                    <div className={styles.advisorInfo}>
                        <h5 className={styles.location}><MapPin size={10} />  {city}, {state} {displayDistance ? ` - ${displayDistance} Away` : ''}</h5>
                        <h3>{firstName}{' '}{lastName}</h3>
                        <h5>{jobTitle && <>{jobTitle} at </>}{companyName}</h5>
                        <h5 className={styles.bottomMargin}>{yearsOfExperience && <>Years of Experience: <b>{yearsOfExperience}</b></>}</h5>
                    </div>
                </div>
                <p className={styles.tagsHeader}>Specialities and Expertise</p>
                <div className={styles.tagsContainer}>
                    {specialities.slice(0, 3).map((specialty, index) => (
                        <div key={index} className={styles.tag}><b>{specialty.value}</b></div>
                    ))}
                    {specialities.length > 3 && <div key={4} className={styles.tag}><b>+{specialities.length - 3}</b></div>}
                </div>
                <p className={styles.tagsHeader}>Typical Clientele</p>
                <div className={styles.tagsContainer}>
                    {clientele.slice(0, 3).map((client, index) => (
                        <div key={index} className={styles.tag}><b>{client.value}</b></div>
                    ))}
                    {clientele.length > 3 && <div key={4} className={styles.tag}><b>+{clientele.length - 3}</b></div>}
                </div>
                <div className={styles.footerContainer}>
                    <div className={styles.footerSection}>
                        <div>
                            Services Provided
                        </div>
                        <ul>
                            {services.slice(0, 3).map((price, index) => (
                                <li key={index}> <b>{price.value}</b></li>
                            ))}
                        </ul>
                    </div>
                    <div className={styles.footerSection}>
                        <div>
                            Pricing Models
                        </div>
                        <ul>
                            {pricing.slice(0, 3).map((range, index) => (
                                <li key={index}> <b>{range.value}</b></li>
                            ))}
                        </ul>
                    </div>
                </div>
            </Link>
        </>
    )
}

export default MarketplaceAdvisorCard;
